import { expose } from "comlink";
import { exportEpub } from "../press/epubGenerator";

const exports = {
    exportEpub
};

export type EpubGeneratorWorker = typeof exports;

expose(exports);